export const SERVER_ICON_LIMIT = 8 * 1024 * 1024;

/** Validate before creating a server; the upload endpoint also checks the bytes. */
export async function validateServerIcon(file: File): Promise<void> {
  if (file.size === 0 || file.size > SERVER_ICON_LIMIT) throw new Error("Choose an image smaller than 8 MB.");
  const bytes = new Uint8Array(await file.slice(0, 16).arrayBuffer());
  const ascii = String.fromCharCode(...bytes);
  const png = [137, 80, 78, 71, 13, 10, 26, 10].every((value, i) => bytes[i] === value);
  const jpeg = bytes[0] === 255 && bytes[1] === 216 && bytes[2] === 255;
  const gif = ascii.startsWith("GIF87a") || ascii.startsWith("GIF89a");
  const webp = ascii.startsWith("RIFF") && ascii.slice(8, 12) === "WEBP";
  if (!png && !jpeg && !gif && !webp) throw new Error("Choose a PNG, JPG, WebP, or GIF image.");
}

type ServerDraft = { name: string; space_type: "community" | "shared_workspace" };
type SetupApi = { create: (draft: ServerDraft) => Promise<{ xid: string }>; uploadIcon: (xid: string, file: File) => Promise<unknown> };

/** Keep the created id before uploading: retries must never create another server. */
export async function completeServerSetup(api: SetupApi, draft: ServerDraft, file: File | null, existingXid: string | null, onCreated: (xid: string) => void): Promise<void> {
  if (file) await validateServerIcon(file);
  let xid = existingXid;
  if (xid === null) {
    const space = await api.create({ ...draft, name: draft.name.trim() });
    xid = space.xid;
    onCreated(xid);
  }
  if (file) await api.uploadIcon(xid, file);
}
